import {useEffect, useState} from 'react';
import {ReleaseNotes} from "./ReleaseNotes";
import {StagingNotes} from "./StagingNotes";
import {Tabs} from "antd";
import {SetUserEmail} from "./SetUserEmail";
import {SetEmailPage} from "../page/SetEmailPage";
import {CartView} from "./CartView";
import {serverType} from "../../api/server";
import {ChangePassword} from "./ChangePassword";

export const GeneralTab = ({session, setEmail, onApiFail, props}) => {
    const [showEmailPage, setShowEmailPage] = useState(false);
    useEffect (() => {
        if (session && session.email === null) {
            setShowEmailPage(true);
        }
    }, [session])

    const onComplete = (email) => {
        if (setEmail) {
            setEmail(email);
        }
    }

    const onCompleteEmail = (email) => {
        setShowEmailPage(false);
        onComplete(email);
    }

    let notesContent = <ReleaseNotes />
    if (serverType === "prod") {
        notesContent = <ReleaseNotes />
    } else {
        notesContent = <StagingNotes />
    }

    const items = [
        {
            key: 'ReleaseNotes',
            label: 'ReleaseNotes',
            children: notesContent
        },
        {
            key: 'ChangePassword',
            label: 'Change Password',
            children: <ChangePassword onApiFail={onApiFail} />
        },
        {
            key: 'SetEmail',
            label: 'Set Email',
            children: <SetUserEmail session={session} onComplete={onComplete} />
        },
        {
            key: 'InventoryReserve',
            label: 'Inventory Reserve',
            children: <CartView session={session} onApiFail={onApiFail}/>
        }
    ];

    if (showEmailPage) {
        return <SetEmailPage session={session} onComplete={onCompleteEmail} />
    }
    return <Tabs tabPosition={'left'} defaultActiveKey={'ReleaseNotes'} items={items} />
}